/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/steve_ui_core").IconRegistry;

IconRegistry.registerIcon("slnman.packageExplorer", require("./rawicons/LmrbPackages.icon.svg"));
IconRegistry.registerIcon("slnman.package", require("./rawicons/package.icon.svg"));
IconRegistry.registerIcon("slnman.launch", require("./rawicons/launch.icon.svg"));
IconRegistry.registerIcon("slnman.dcrepo", require("./rawicons/DistributionCenter.icon.svg"));
IconRegistry.registerIcon("slnman.filerepo", require("./rawicons/FileBasedPackageRepository.icon.svg"));
IconRegistry.registerIcon("slnman.expandCollapse", require("./rawicons/expandCollapse.icon.svg"));
